// import "@formatjs/intl-pluralrules/polyfill";
import "intl-pluralrules";
import i18n from "i18next";
import HttpBackend from "i18next-http-backend";
import { useCallback, useState } from "react";
import { initReactI18next, useTranslation } from "react-i18next";
class ExtHttpBackend extends HttpBackend {
    loadUrl(url, callback, languages, namespaces) {
        console.log("Loading url: ", url);
        const maxAttempts = 5;
        const attemptLoadUrl = (attemptIdx, nextDelay) => {
            super.loadUrl(url, (err, data) => {
                if (err) {
                    console.error("i18n-loading-error:", err);
                    if (attemptIdx >= maxAttempts) {
                        callback(err, data);
                    }
                    else {
                        setTimeout(() => {
                            attemptLoadUrl(attemptIdx + 1, nextDelay * 2);
                        }, nextDelay);
                    }
                }
                else {
                    callback(err, data);
                }
            }, languages, namespaces);
        };
        attemptLoadUrl(0, 1000 /* ms */);
    }
}
export const useI18Next = (API_BASE) => {
    const [isInitialized, setInitialized] = useState(false);
    const initialize = useCallback(() => {
        i18n.use(initReactI18next)
            .use(ExtHttpBackend)
            .init({
            debug: true,
            fallbackLng: "en-IN",
            backend: {
                crossDomain: true,
                loadPath: `${API_BASE}/locales/{{lng}}/{{ns}}.json`,
            },
            react: {
                useSuspense: false,
            },
        })
            .catch(e => {
            console.error("Failed to initialize i18next", e);
        })
            .finally(() => {
            setInitialized(true);
        });
    }, []);
    const changeLanguage = useCallback((localeCode) => {
        setInitialized(false);
        i18n.changeLanguage(localeCode).finally(() => {
            setInitialized(true);
        });
    }, []);
    return {
        initialize,
        isInitialized,
        changeLanguage,
    };
};
export { useTranslation };
//# sourceMappingURL=i18n.js.map